/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
Buyapowa.Helpers.ManualEmailShare = class ManualEmailShare {
  constructor(el, sendButtonEl, personalMessageEl, personalSubjectEl, shareUrlTextEl) {
    this.el = el;
    this.sendButtonEl = sendButtonEl;
    this.personalMessageEl = personalMessageEl;
    this.personalSubjectEl = personalSubjectEl;
    this.shareUrlTextEl = shareUrlTextEl;
    if (Buyapowa.Helpers.Browser.iOSVersion() >= 10) {
      this._handleLinkClickAndOpenMailToWindow();
    } else {
      this._updateLinkWithPersonalMessage();
    }
  }

  _updateLinkWithPersonalMessage() {
    this.sendButtonEl.on("click", () => {
      // Don't stop the default action
      this._trackEvent();
      return true;
    });

    const updater = () => {
      return this.sendButtonEl.attr("href", `mailto:?subject=${encodeURIComponent(this.personalSubjectEl.val())}&body=${encodeURIComponent(this._bodyContent())}`);
    };

    this.personalMessageEl.on("change", updater);
    return updater();
  }

  _handleLinkClickAndOpenMailToWindow() {
    return this.sendButtonEl.on("click", e => {
      e.preventDefault();

      this._trackEvent();

      const w = window.open(`mailto:?subject=${encodeURIComponent(this.personalSubjectEl.val())}&body=${encodeURIComponent(this._bodyContent())}`, "_top");
      const x = () => w.close();
      return setTimeout(x, 1000);
    });
  }

  _trackEvent() {
    return eval(this.el.data("track-method") + "()");
  }

  _bodyContent() {
    return `${this.personalMessageEl.val()} \n\n${this.shareUrlTextEl.val()}`;
  }
};
